import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { change } from 'redux-form';

import { CLIENT_ALLOWANCE_FORM } from 'src/constants/FormNames';
import { getRadioOptions } from 'src/reducers/selectOptions';
import { getAllowanceFormValues } from 'src/reducers/clients/allowances';
import selector from 'src/utils/Utils';
import { Label } from 'jbc-front/components/Form';

import SelectLeftRightItems from './SelectLeftRightItems';

const LeavesTable = ({ leaveTypes, clientAllowanceItemIds, dispatch }) => {
  const { t } = useTranslation();
  const leftItems = leaveTypes || [];

  const filterRightItems = leaveTypes.filter(item => clientAllowanceItemIds?.includes(item.value));

  const [rightItems, setRightItems] = useState(filterRightItems || []);
  const [selectingItems, setSelectingItems] = useState({ left: [], right: [] });

  const changeParentState = newData => {
    setRightItems(newData);
    dispatch(change(CLIENT_ALLOWANCE_FORM, 'clientAllowanceItemIds', newData.map(item => item.value)));
  };

  return (
    <div>
      <div className="d-flex justify-content-between">
        <Label
          text={t('features.ClientMotivation.global.type_of_leave')}
          note={t('features.ClientMotivation.components.MonthlySteppedBonus.motivation_bonus_setting_note')}
        />
      </div>

      <SelectLeftRightItems
        {...{
          leftItems,
          rightItems,
          changeParentState,
          selectingItems,
          setSelectingItems
        }}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  leaveTypes: getRadioOptions(state, 'leaveTypes'),
  clientPayrollRulesGroupId: selector(getAllowanceFormValues(state), 'clientPayrollRulesGroupId'),
  clientAllowanceItemIds: selector(getAllowanceFormValues(state), 'clientAllowanceItemIds')
});

export default connect(mapStateToProps)(LeavesTable);
